import Vue from 'vue'
//import  './plugins/vuetify'
import App from './App.vue'
import router from './router'
import store from './store'
import VueResource from 'vue-resource';
//import './registerServiceWorker'
import '@babel/polyfill'
import Vuetify, {
    VApp,
    VNavigationDrawer,
    VFooter,
    VList,
    VBtn,
    VIcon,
    VGrid,
    VToolbar,
    transitions,
    VCarousel,
    VChip,
    VAvatar,
    VBadge,
    VParallax,
    VDialog,
    VForm,
    VTextField,
    VDataTable,
    VDivider,
    VSelect,
    VPagination,
    VMenu,
    VTabs,
    VCard,
    VImg,
    VSnackbar
} from 'vuetify/lib'
import { Resize, Scroll} from 'vuetify/lib/directives'
Vue.use(Vuetify, {
    components: {
        VApp,
        VNavigationDrawer,
        VFooter,
        VList,
        VBtn,
        VIcon,
        VGrid,
        VToolbar,
        transitions,
        VCarousel,
        VChip,
        VAvatar,
        VBadge,
        VParallax,
        VDialog,
        VForm,
        VTextField,
        VDataTable,
        VDivider,
        VSelect,
        VPagination,
        VMenu,
        VTabs,
        VCard,
        VImg,
        VSnackbar,
    },
    directives: {
        Resize, Scroll
    },
    theme: {
        primary: '#000bee',
        secondary: '#424242',
        accent: '#82B1FF',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107'
    }
})
import 'vuetify/src/stylus/app.styl'
//import wysiwyg from 'vue-wysiwyg'
/*import {
    Vuetify,
    VApp,
    VNavigationDrawer,
    VFooter,
    VList,
    VBtn,
    VIcon,
    VGrid,
    VToolbar,
    transitions,
    VCarousel,
    VChip,
    VAvatar,
    VBadge,
    VParallax,
    VDialog,
    VForm,
    VTextField,
    VDataTable,
    VDivider,
    VSelect,
    VPagination,
    VMenu,
    VTabs,
    VCard,
    VImg,
    VSnackbar
} from 'vuetify/lib'
import '../node_modules/vuetify/src/stylus/app.styl';
*/
import Auth from './plugins/auth/Auth';
import Ga from './plugins/ga/analytics';
import Helper from './plugins/helper/helperFunctions';
//Vue.use(wysiwyg, {hideModules: {'image': true}})


/*Vue.use(Vuetify, {
    components: {
        VApp,
        VNavigationDrawer,
        VFooter,
        VList,
        VBtn,
        VIcon,
        VGrid,
        VToolbar,
        transitions,
        VCarousel,
        VChip,
        VAvatar,
        VBadge,
        VParallax,
        VDialog,
        VForm,
        VTextField,
        VDataTable,
        VDivider,
        VSelect,
        VPagination,
        VMenu,
        VTabs,
        VCard,
        VImg,
        VSnackbar,
    },
    directives,
    theme: {
        primary: '#000bee',
        secondary: '#424242',
        accent: '#82B1FF',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107'
    }
})*/
import VueYoutube from 'vue-youtube'
import Croppa from 'vue-croppa';
import 'vue-croppa/dist/vue-croppa.css';
Vue.use(Croppa);

Vue.use(VueYoutube)

Vue.use(VueResource);
Vue.use(Auth);
Vue.use(Ga);
Vue.use(Helper);

Vue.config.productionTip = false

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
